// Catalogo de servicios que se muestran como "disponibles para agregar".
//
// Son solo informativos: aparecen en gris con un candado y, al pulsarlos, sale
// el mismo aviso de "contacta al administrador". NO se pueden abrir ni se
// activan solos: para que un cliente los use de verdad hay que darlos de alta
// en la base de datos como las demas aplicaciones.
//
// Las imagenes van en frontend/public/img/ con exactamente estos nombres.
// Si un archivo no esta, la tarjeta muestra las iniciales en su lugar.
//
// OJO con las iniciales: la tarjeta no muestra el titulo debajo, asi que si
// falta la imagen quedan varias iguales (Insite e Incal darian las dos "IN").
// Por eso cada programa de diesel lleva su rotulo, con el nombre y la version
// dentro del propio cuadro.
//
// Son DOS listas porque en pantalla van bajo dos titulos distintos:
// "Available to add" y "Heavy Duty Software".

// ---------------------------------------------------------------------------
// Diagnostico general
// ---------------------------------------------------------------------------
exports.catalog = [
  {
    key: "ford-ids",
    tittle: "Ford IDS",
    description: "Integrated Diagnostic System",
    img: "/img/ford-ids.jpg",
  },
  {
    key: "mitchell-ultramate",
    tittle: "Mitchell UltraMate",
    description: "Estimating for collision repair",
    img: "/img/mitchell-ultramate.jpg",
  },
  {
    key: "mitchell1-truckseries",
    tittle: "Mitchell 1 TruckSeries",
    description: "Repair information for commercial trucks",
    img: "/img/mitchell1-truckseries.jpg",
  },
  {
    key: "mitchell1-prodemand",
    tittle: "Mitchell 1 ProDemand",
    description: "Repair, estimating and maintenance",
    img: "/img/mitchell1-prodemand.jpg",
  },
  {
    key: "mitchell-enlyte",
    tittle: "Mitchell",
    description: "An Enlyte company",
    img: "/img/mitchell-enlyte.png",
  },
];

// ---------------------------------------------------------------------------
// Vehiculo pesado (diesel)
// ---------------------------------------------------------------------------
exports.heavyDuty = [
  {
    key: "insite",
    tittle: "Cummins INSITE 9.3",
    description: "Engine diagnostics for Cummins",
    img: "/img/insite.svg",
  },
  {
    key: "calterm",
    tittle: "Cummins Calterm 5.16",
    description: "Calibration and parameter editing",
    img: "/img/calterm.svg",
  },
  {
    key: "incal",
    tittle: "Cummins INCAL 9.1",
    description: "Calibration files for Cummins engines",
    img: "/img/incal.svg",
  },
  {
    key: "dddl",
    tittle: "Detroit DDDL 8.22",
    description: "Detroit Diesel Diagnostic Link",
    img: "/img/dddl.svg",
  },
  {
    key: "jpro",
    tittle: "JPRO 2026",
    description: "Commercial fleet diagnostics",
    img: "/img/jpro.svg",
  },
  {
    key: "etech-214",
    tittle: "Mack E-Tech 2.14",
    description: "Diagnostics for Mack engines",
    img: "/img/etech-214.svg",
  },
  {
    key: "etech-215",
    tittle: "Mack E-Tech 2.15",
    description: "Diagnostics for Mack engines",
    img: "/img/etech-215.svg",
  },
  {
    key: "service-ranger",
    tittle: "Eaton ServiceRanger 4.13",
    description: "Transmission diagnostics",
    img: "/img/service-ranger.svg",
  },
  {
    key: "hino-dx2",
    tittle: "Hino DX 2",
    description: "Diagnostics for Hino trucks",
    img: "/img/hino-dx2.svg",
  },
  {
    key: "hino-dx3",
    tittle: "Hino DX 3",
    description: "Diagnostics for Hino trucks",
    img: "/img/hino-dx3.svg",
  },
  {
    key: "ned",
    tittle: "NED 2025",
    description: "Navistar engine diagnostics",
    img: "/img/ned.svg",
  },
  {
    key: "dlb",
    tittle: "DLB 2025",
    description: "Diamond Logic Builder",
    img: "/img/dlb.svg",
  },
  {
    key: "sds",
    tittle: "SDS 2025",
    description: "Service diagnostic software",
    img: "/img/sds.svg",
  },
  {
    key: "allison",
    tittle: "Allison DOC 2024",
    description: "Transmission diagnostics",
    img: "/img/allison.svg",
  },
  {
    key: "bendix",
    tittle: "Bendix ACom 2024",
    description: "Brake system diagnostics",
    img: "/img/bendix.svg",
  },
];

// ---------------------------------------------------------------------------
// DIESEL REMOTE SOFTWARE INSTALL: programas que el taller instala a distancia.
// Se ven al tocar esa tarjeta (la ven TODOS los clientes). Solo informativo:
// al elegir uno sale su descripcion y el aviso de contactar al administrador.
// Imagenes en frontend/public/img/diesel/.
// ---------------------------------------------------------------------------
exports.dieselInstall = [
  {
    key: "insite-10",
    tittle: "Cummins INSITE",
    version: "v10.0.0 · 2026",
    img: "/img/diesel/insite-10.jpg",
    description:
      "Dealer-level diagnostic software for Cummins engines: read and clear fault codes, live data, diagnostic tests and engine parameter adjustments.",
  },
  {
    key: "calterm-516",
    tittle: "Cummins Calterm",
    version: "5.16",
    img: "/img/diesel/calterm-516.jpg",
    description:
      "Cummins engineering tool to monitor the engine ECM in real time and view or adjust calibration parameters and feature settings.",
  },
  {
    key: "dddl-824",
    tittle: "Detroit DiagnosticLink",
    version: "8.24 · 2026.07",
    img: "/img/diesel/dddl-824.jpg",
    description:
      "Dealer-level diagnostics for Detroit Diesel engines, Freightliner and Western Star trucks and DT12 transmissions: codes, live data, service routines and parameters.",
  },
  {
    key: "allison-doc-2024",
    tittle: "Allison DOC",
    version: "2024",
    img: "/img/diesel/allison-doc-2024.jpg",
    description:
      "Diagnostics for Allison automatic transmissions: fault codes, live data, troubleshooting guides, shift adaptive reset and reports.",
  },
  {
    key: "bendix-acom-2024",
    tittle: "Bendix ACom PRO",
    version: "2024 v2",
    img: "/img/diesel/bendix-acom-2024.jpg",
    description:
      "Diagnostics for Bendix systems: ABS, air brakes, stability control and driver-assistance (Wingman), with fault codes and component tests.",
  },
  {
    key: "eaton-serviceranger-413",
    tittle: "Eaton ServiceRanger",
    version: "4.13",
    img: "/img/diesel/eaton-serviceranger-413.jpg",
    description:
      "Diagnostics for Eaton and Eaton Cummins transmissions and clutches: fault codes, data monitor, service routines and reports.",
  },
  {
    key: "jpro-2025",
    tittle: "JPRO Commercial Vehicle Diagnostics",
    version: "2025 v2",
    img: "/img/diesel/jpro-2025.jpg",
    description:
      "Multi-brand diagnostics for heavy-duty trucks: engines, transmissions, ABS and body systems from one program, with fault codes and live data.",
  },
  {
    key: "cat-et-2026a",
    tittle: "CAT ET (Electronic Technician)",
    version: "2026A v1.0",
    img: "/img/diesel/cat-et-2026a.jpg",
    description:
      "Caterpillar diagnostic software for CAT engines and equipment: fault codes, live status, tests, calibrations and configuration parameters.",
  },
  {
    key: "perkins-est-2026a",
    tittle: "Perkins EST",
    version: "2026A",
    img: "/img/diesel/perkins-est-2026a.jpg",
    description:
      "Perkins Electronic Service Tool for Perkins engines: fault codes, live data, diagnostic tests and engine configuration.",
  },
  {
    key: "navistar-sds-ned-dlb",
    tittle: "Navistar SDS-Pro + NED + DLB",
    version: "SDS-Pro 1.9.7 · NED + DLB 2025",
    img: "/img/diesel/navistar-sds-ned-dlb.jpg",
    description:
      "International / Navistar package: NED for engine diagnostics, Diamond Logic Builder (DLB) for chassis electrical programming and SDS-Pro service diagnostics.",
  },
  {
    key: "hino-dx3-1262",
    tittle: "Hino DX III (Diagnostic Explorer)",
    version: "v1.26.2 · 2026",
    img: "/img/diesel/hino-dx3-1262.jpg",
    description:
      "Hino Diagnostic Explorer for Hino trucks: fault codes, live data, active tests, DPR regeneration and ECU settings.",
  },
  {
    key: "isuzu-idss",
    tittle: "Isuzu IDSS",
    version: "Diagnostic Service System",
    img: "/img/diesel/isuzu-idss.jpg",
    description:
      "Isuzu Diagnostic Service System for N-Series and F-Series trucks: vehicle auto-detect, fault codes, live data, tests and service bulletins.",
  },
  {
    key: "cnh-est-915",
    tittle: "CNH EST",
    version: "9.15",
    img: "/img/diesel/cnh-est-915.jpg",
    description:
      "CNH Electronic Service Tool for Case IH, New Holland and Steyr tractors and equipment: controller diagnostics, fault codes and configuration.",
  },
];

// ---------------------------------------------------------------------------
// CARS REMOTE SOFTWARE INSTALL: igual que dieselInstall, para autos.
// Imagenes en frontend/public/img/cars/. Mientras este vacia, la tarjeta no sale.
// ---------------------------------------------------------------------------
exports.carsInstall = [
  {
    key: "bmw-ista-460",
    tittle: "BMW ISTA+",
    version: "4.60.30",
    img: "/img/cars/bmw-ista-460.jpg",
    description:
      "BMW and MINI workshop system: full diagnostics, test plans, fault codes, live data, service functions and repair instructions.",
  },
  {
    key: "mercedes-xentry-2026",
    tittle: "Mercedes-Benz Xentry",
    version: "2026.9",
    img: "/img/cars/mercedes-xentry-2026.jpg",
    description:
      "Dealer-level diagnostics for Mercedes-Benz cars, vans and trucks (MB Star / SD Connect): fault codes, live data, guided tests and coding.",
  },
  {
    key: "toyota-techstream-v18",
    tittle: "Toyota Techstream",
    version: "V18",
    img: "/img/cars/toyota-techstream-v18.jpg",
    description:
      "Toyota, Lexus and Scion diagnostics: fault codes, live data, active tests, system resets and customization settings.",
  },
  {
    key: "hp-tuners",
    tittle: "HP Tuners VCM Suite",
    version: "VCM Editor · VCM Scanner",
    img: "/img/cars/hp-tuners.jpg",
    description:
      "Performance tuning and scanning: read and edit engine and transmission calibrations, data logging and diagnostics for GM, Ford, Dodge and more.",
  },
  {
    key: "ford-ids",
    tittle: "Ford IDS",
    version: "Integrated Diagnostic System",
    img: "/img/cars/ford-ids.jpg",
    description:
      "Ford and Lincoln dealer diagnostics: fault codes, live data, self-tests, module programming and key/PATS functions.",
  },
];
